import TicketOfferCreateContainer from "./TicketOfferCreateContainer"


const OfferCreate = () => {
  return (
    <div className='page-body'>
      <TicketOfferCreateContainer />
    </div>
  )
}

export default OfferCreate